import SearchModal from "../../components/common/search/SearchModal";
import { CheckCircleOutlined } from "@ant-design/icons";
import SellImage from "../../assets/sell.png";
import CategoryHeader from "../../components/category/CategoryHeader";
import BrandGrid from "../../components/brand/BrandGrid";

export const HeroSection = ({
  categorySlug,
  getHeroTitle,
  getHeroSubtitle,
  quickBrands,
  isDarkMode,
  cleanDeviceName,
  categoryName,
  city,
}) => {
  const placeholderTexts = [`Search Your ${categoryName} to Sell`];

  const featureBadges = [
    { id: 1, label: "Best Price", icon: CheckCircleOutlined },
    { id: 2, label: "Secure", icon: CheckCircleOutlined },
    { id: 3, label: "Free Pickup", icon: CheckCircleOutlined },
    { id: 4, label: "Instant Pay", icon: CheckCircleOutlined },
  ];

  return (
    <div
      className={`border-b ${isDarkMode ? "border-gray-700 bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900" : "border-gray-100 bg-gradient-to-br from-blue-50 via-white to-purple-50"}`}
    >
      <div className="px-4 py-6 mx-auto max-w-7xl sm:py-8">
        {/* Mobile Layout: Image on Top */}
        <div className="flex flex-col gap-6 lg:hidden">
          <div className="grid grid-cols-3 gap-2">
            <h1
              className={`mb-2 col-span-2 text-2xl font-bold sm:text-3xl ${!isDarkMode ? "text-transparent bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text" : "text-white"}`}
            >
              {getHeroTitle()}
            </h1>
            <img
              src={SellImage}
              alt="Sell Smartphone"
              className="object-contain w-48 h-auto sm:w-64"
            />
          </div>

          <div className="text-center">
            <div className="max-w-md mx-auto">
              <SearchModal
                isDesktop={true}
                isDarkMode={isDarkMode}
                placeholderTexts={placeholderTexts}
              />
            </div>
          </div>
        </div>

        {/* Desktop Layout: Image on Right */}
        <div className="hidden lg:flex lg:flex-row lg:items-center lg:justify-between lg:gap-8">
          <div className="flex-1 text-left">
            <h1
              className={`mb-2 text-4xl font-bold ${!isDarkMode ? "text-transparent bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text" : "text-white"}`}
            >
              {getHeroTitle()}
            </h1>

            <p
              className={`mb-3 text-base ${isDarkMode ? "text-gray-300" : "text-gray-600"}`}
            >
              {getHeroSubtitle()}
            </p>

            <div className="flex flex-wrap gap-2 mb-4">
              {featureBadges.map((badge) => {
                const IconComponent = badge.icon;
                return (
                  <div
                    key={badge.id}
                    className={`rounded-[5px] font-semibold px-3 py-1 flex items-center gap-1.5 ${isDarkMode ? "bg-gray-800" : "bg-gray-100"}`}
                  >
                    <IconComponent className="text-sm text-green-500" />
                    <span
                      className={`text-sm ${isDarkMode ? "text-gray-300" : "text-gray-700"}`}
                    >
                      {badge.label}
                    </span>
                  </div>
                );
              })}
            </div>

            <div className="max-w-md">
              <SearchModal
                isDesktop={true}
                isDarkMode={isDarkMode}
                placeholderTexts={placeholderTexts}
              />
            </div>
          </div>

          <div className="flex justify-center flex-1">
            <img
              src={SellImage}
              alt="Sell Smartphone"
              className="object-contain w-[400px] h-auto"
            />
          </div>
        </div>
        {quickBrands.length > 0 && (
          <div className="container px-4 py-2 mx-auto max-w-7xl">
            <CategoryHeader
              title="Or Choose a Brand"
              subtitle={`Choose from our most popular brands to get the best price for your ${cleanDeviceName.toLowerCase()}`}
              brandCount={quickBrands.length}
              isDarkMode={isDarkMode}
            />
            <BrandGrid
              city={city}
              categorySlug={categorySlug}
              brands={quickBrands}
              isDarkMode={isDarkMode}
            />
          </div>
        )}
      </div>
    </div>
  );
};
